import { render } from "./ErrorMssageCard.vue?vue&type=template&id=0fad3918&ts=true"
import script from "./ErrorMssageCard.vue?vue&type=script&lang=ts"
export * from "./ErrorMssageCard.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__